<template>
    <Popup ref="popup" :animation="'scale'">
        <!--div class="airdrop-container"-->
        <div :class="getContainerClass()">
            <img class="close-btn" :src="_global.assetsRoot + '/airdrop_collect_btn_close.png'" @click.stop="hide">
            <div class="sections-container" @click="collectAirShop()" :class="{ gap: airdrop.length === 2 }">
                <div class="item-container" v-for="(airdrop, i) in airdrop" :key="i"
                    :class="getItemClass(airdrop)">
                    <div class="item">
                        <img :src="airdrop.image">
                        <div class="stars-container" v-if="airdrop.type === 'shop_items'">
                            <img :src="getImagePath('airdrop_star.png')" v-for="n in parseInt(airdrop.item_star)"
                                :key="n">
                        </div>
                    </div>
                    <h2 class="title"><img v-if="airdrop.type === 'coins'"
                            :src="_global.assetsRoot + '/airdrop_coin.png'">{{
                                getTitle(airdrop) }}</h2>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import api from '../../network/api';
import Popup from '../Popup.vue';
export default {
    props: {
        userID: String
    },
    data() {
        return {
            airdrop: {}
        }
    },
    created() {
        if (this._global.airdrop) {
            this.airdrop = this._global.airdrop;
        }
        this.addImagePaths();
    },
    methods: {
        show() { this.$refs.popup.show() },
        hide() { this.$refs.popup.hide() },
        collectAirShop() {
            api.collectAirShop(this.userID).then((resp) => {
                //console.log(resp)
                this.$emit('airdrop-collected-coins', resp);
                this.$emit('open-redeem');
                this.hide();
            });
            /*let resp = {
                data: {
                    coins: 100
                }
            }
            this.$emit('airdrop-collected-coins', resp);
            this.$emit('open-redeem');
            this.hide();*/
        },
        getContainerClass(){
            let userLanguage = this._global.user.lang;
            //userLanguage = 'en';
            //console.log("User lang", userLanguage);

            switch(userLanguage){
                case 'pt':
                    return 'airdrop-container airdrop-container-pt';
                    break;
                case 'es':
                    return 'airdrop-container airdrop-container-es';
                    break;
                default:
                    return 'airdrop-container airdrop-container-en';
                    break
            }
        },
        getImagePath(imageName) {
            //return require(`../../assets/images/${imageName}`);
            return this._global.assetsRoot + '/' + imageName;
        },
        getImageForType(airdrop) {
            if (airdrop.type === 'coins') {
                return this.getImagePath('airdrop_coins.png');
            } else if (airdrop.type === 'shop_items') {
                switch (airdrop.item_type) {
                    case '1':
                        return this.getImagePath('wild_card.png');
                    case '2':
                        return this.getImagePath('airdrop_capsule.png');
                    case '3':
                        return this.getImagePath('sticker_pack.png');
                    case '4':
                        return this.getImagePath('airdrop_red_coupon.png');
                    case '5':
                        return this.getImagePath('airdrop_dice.png');
                    case '6':
                        return this.getImagePath('mechanical_gloves.png');
                    case '7':
                        return this.getImagePath('jogo_do_bicho_ticket.png');
                    case '8':
                        return this.getImagePath('magnetic_ball.png');
                    case '9':
                        return this.getImagePath('potion_of_luck.png');
                    case '10':
                        return this.getImagePath('machine_of_spins.png');
                    case '11':
                        return this.getImagePath('VIP voucher points.png');
                    case '12':
                        return this.getImagePath('vacuum cleaner.png');
                    case '13':
                        return this.getImagePath('nutrient.png');
                    default:
                        return '';
                }
            }
        },
        getTitle(airdrop) {
            if (airdrop.type === 'coins') {
                return `${airdrop.value}`;
            } else if (airdrop.type === 'shop_items') {
                switch (airdrop.item_type) {
                    case '1':
                        return '1 Wild Card';
                    case '2':
                        return '1 Time Capsule';
                    case '3':
                        return '1 Sticker Pack';
                    case '4':
                        return '1 Red Coupon';
                    case '5':
                        return '1 Dice';
                    case '6':
                        return '1 Mechanical Gloves';
                    case '7':
                        return '1 Jogo Do Bicho Ticket';
                    case '8':
                        return '1 Magnetic Ball';
                    case '9':
                        return '1 Potion Of Luck';
                    case '10':
                        return '1 Machine Of Spins';
                    case '11':
                        return '1 VIP Voucher';
                    case '12':
                        return '1 Vacuum Cleaner';
                    case '13':
                        return '1 Nutrient';
                    default:
                        return '';
                }
            }
        },
        getItemClass(airdrop) {
            if (airdrop.type === 'coins') {
                return 'item-coins';
            } else if (airdrop.type === 'shop_items') {
                switch (airdrop.item_type) {
                    case '2':
                        return 'item-time-capsule';
                    case '4':
                        return 'item-red-coupon';
                    case '5':
                        return 'item-dice';
                    default:
                        return 'item-dice';
                }
            }
        },
        addImagePaths() {
            this.airdrop.forEach(item => {
                item.image = this.getImageForType(item);
            });
        },
    },
    components: {
        Popup,
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";
@import url('https://fonts.googleapis.com/css2?family=Luckiest+Guy&display=swap');

.airdrop-container-pt{
    background: url($assetRoot + "/airdrop_congratulations_pt.png") center no-repeat;
}
.airdrop-container-en{
    background: url($assetRoot + "/airdrop_congratulations_en.png") center no-repeat;
}
.airdrop-container-es{
    background: url($assetRoot + "/airdrop_congratulations_es.png") center no-repeat;
}
.airdrop-container {
    width: 80%;
    height: 84vh;
    background-size: 100% 100%;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;

    .close-btn {
        width: 112px;
        height: 112px;
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
        z-index: 2;
    }

    .gap {
        gap: 72px !important;
    }

    .sections-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 52px;

        .item-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .item {
                width: 190px;
                height: 170px;
                background: url($assetRoot + "/airdop_bg_light.png") center no-repeat;
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;

                img {
                    width: 120px;
                    height: 120px;
                }

                .stars-container {
                    display: flex;
                    gap: 1px;
                    position: absolute;
                    bottom: 32px;
                    right: 20px;

                    img {
                        width: 28px;
                        height: 28px;
                    }
                }
            }

            .title {
                background: url($assetRoot + "/airdrop_collect_text_bg.png") center no-repeat;
                background-size: 100% 100%;
                font-family: "Luckiest Guy", cursive;
                font-size: 32px;
                font-weight: 500;
                margin: 0 !important;
                padding: 4px 12px;
            }
        }
    }

    .item-coins {
        .item>img {
            width: 200px !important;
        }

        .title {
            color: #ffe035;
            -webkit-text-stroke-width: 2px;
            -webkit-text-stroke-color: #c26808;
            display: flex;
            align-items: center;

            img {
                width: 36px;
                height: 36px;
                margin-right: 12px;
            }
        }
    }

    .item-dice {
        .title {
            color: #ffffff;
            -webkit-text-stroke-color: #17783c;
            -webkit-text-stroke-width: 2px;
        }
    }

    .item-time-capsule {
        .title {
            color: #ffffff;
            -webkit-text-stroke-color: #c704bf;
            -webkit-text-stroke-width: 2px;
        }
    }

    .item-red-coupon {
        .title {
            color: #ffffff;
            -webkit-text-stroke-color: #c9493b;
            -webkit-text-stroke-width: 2px;
        }
    }
}

.mobile {
    .airdrop-container-pt{
        background: url($assetRoot + "/airdrop_congratulations_m_pt.png") center no-repeat;
    }
    .airdrop-container-en{
        background: url($assetRoot + "/airdrop_congratulations_m_en.png") center no-repeat;
    }
    .airdrop-container-es{
        background: url($assetRoot + "/airdrop_congratulations_m_es.png") center no-repeat;
    }
    .airdrop-container {
        width: 100%;
        height: 56vh;
        background-size: 100% 100%;

        .close-btn {
            width: 80px;
            height: 80px;
            position: absolute;
            top: 32px;
            right: -2px;
        }

        .gap {
            gap: 38px !important;
        }

        .sections-container {
            gap: 10px;

            .item-container {
                position: relative;
                bottom: 24px;
                width: 25%;

                .item {
                    width: 120px;
                    height: 100px;

                    img {
                        width: 80px;
                        height: 80px;
                    }

                    .stars-container {
                        bottom: 20px;
                        right: 12px;

                        img {
                            width: 18px;
                            height: 18px;
                        }
                    }
                }

                .title {
                    font-size: 16px;
                    -webkit-text-stroke-width: 1px !important;
                }
            }
        }
    }

    .item-coins {
        .item>img {
            width: 100px !important;
        }

        .title {

            img {
                width: 18px;
                height: 18px;
                margin-right: 8px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Award.vue